import {Component, OnInit} from "@angular/core";
import {Subject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-job-foc-and-abort',
    templateUrl: 'job-foc-and-abort.component.html',
    styleUrls: ['job-foc-and-abort.component.css']
})

export class JobFocAndAbortComponent implements OnInit {
    public onClose: Subject<boolean>;
    title:string='';
    reasons:any;
    labelType:string='';
    select2Config:any = {};
    jobForm: FormGroup;
    constructor(public sidePanelModalRef: BsModalRef,
                private fb: FormBuilder){}
    ngOnInit() {
        this.onClose = new Subject();
        this.select2Config = {
            width: '100%'
        }
        this.jobForm = this.fb.group({
            reason: ['', Validators.required],
            note: ['']
        });
    }
    onSubmit() {
        this.onClose.next(this.jobForm.value);
        this.sidePanelModalRef.hide();
    }

}
